import Link from '@mui/material/Link';
import { Link as RouterLink } from "react-router-dom";

const RegisterInterestLink = () => {
  return (
    <Link
      color="inherit"
      target="_blank"
      rel="noopener"
      to={"https://forms.gle/VtEUr1rnEVbhZMXa9"}
      component={RouterLink}
    >
      here
    </Link>
  )
}

export default RegisterInterestLink;